import {
  ADD_SERVICE,
  ADD_SERVICE_COMPLEMENTAIRE,
  UPDATE_SERVICE,
  REMOVE_SERVICE,
  ADD_REALISATION,
  UPDATE_REALISATION,
  REMOVE_REALISATION,
  ADD_PHOTO,
  REMOVE_PHOTO,
  CLEAR_SERVICES,
  REMOVE_SERVICE_COMPLEMENTAIRE,
} from '../actions/serviceActions';

const initialState = {
  services: []
};

export default function serviceReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_SERVICE:
      return {
        ...state,
        services: [
          ...state.services,
          {
            ...action.payload,
            realisations: [],
            complementaires: [],
          }
        ]
      };

    case UPDATE_SERVICE:
      return {
        ...state,
        services: state.services.map((service, idx) =>
          idx === action.payload.index
            ? { ...service, ...action.payload.data }
            : service
        )
      };
    case ADD_SERVICE_COMPLEMENTAIRE:
      return {
        ...state,
        services: state.services.map((service) =>
          service.id === action.payload.serviceId
            ? {
                ...service,
                complementaires: [
                  ...(service.complementaires || []),
                  { ...action.payload.complementaire }
                ]
              }
            : service
        )
      };



    case REMOVE_SERVICE:
  return {
    ...state,
    services: state.services.filter(
      (service) => service.id !== action.payload
    )
  };


    case ADD_REALISATION:
  return {
    ...state,
    services: state.services.map((service, idx) =>
      idx === action.payload.serviceIndex
        ? {
            ...service,
            realisations: [
              ...service.realisations,
              {
                ...action.payload.realisation,
                photos: action.payload.realisation.photos || []
              }
            ]
          }
        : service
    )
  };


    case UPDATE_REALISATION:
      return {
        ...state,
        services: state.services.map((service, sIdx) =>
          sIdx === action.payload.serviceIndex
            ? {
                ...service,
                realisations: service.realisations.map((real, rIdx) =>
                  rIdx === action.payload.realisationIndex
                    ? { ...real, ...action.payload.data }
                    : real
                )
              }
            : service
        )
      };

    case REMOVE_REALISATION:
  return {
    ...state,
    services: state.services.map((service) =>
      service.id === action.payload.serviceIndex
        ? {
            ...service,
            realisations: service.realisations.filter(
              (realisation) => realisation.id !== action.payload.realisationIndex
            )
          }
        : service
    )
  };


    case ADD_PHOTO:
      return {
        ...state,
        services: state.services.map((service, sIdx) =>
          sIdx === action.payload.serviceIndex
            ? {
                ...service,
                realisations: service.realisations.map((real, rIdx) =>
                  rIdx === action.payload.realisationIndex
                    ? {
                        ...real,
                        photos: [...real.photos, action.payload.photo]
                      }
                    : real
                )
              }
            : service
        )
      };

    case REMOVE_PHOTO:
      return {
        ...state,
        services: state.services.map((service, sIdx) =>
          sIdx === action.payload.serviceIndex
            ? {
                ...service,
                realisations: service.realisations.map((real, rIdx) =>
                  rIdx === action.payload.realisationIndex
                    ? {
                        ...real,
                        photos: real.photos.filter(
                          (_, pIdx) => pIdx !== action.payload.photoIndex
                        )
                      }
                    : real
                )
              }
            : service
        )
      };
    case REMOVE_SERVICE_COMPLEMENTAIRE:
      return {
        ...state,
        services: state.services.map((service) => {
          if (service.id !== action.payload.serviceId) {
            return service;
          }
          return {
            ...service,
            complementaires: service.complementaires.filter(
              (c) => c.id !== action.payload.complementaireId
            ),
          };
        }),
      };


    case CLEAR_SERVICES:
      return initialState;

    default:
      return state;
  }
}
